/**
 * Decide se o drawer de configuração ("nova execução") deve abrir
 * automaticamente ao montar a workbench de um agente.
 *
 * Intenção (call-to-action): quando o usuário entra na página e NÃO há
 * execução nenhuma, abrimos o formulário pra ele rodar. Caso contrário,
 * deixamos fechado — a página mostra a última run.
 *
 * O bug que isto corrige: a decisão era tomada antes da query de execuções
 * resolver (lista vinha `[]` por um instante), então o drawer abria em TODA
 * navegação, mesmo com runs concluídas. Por isso `executionsLoading` é um
 * guard de primeira classe — não decidimos até a lista carregar.
 */
export interface AutoOpenConfigInput {
  /** Já abrimos uma vez nesta montagem? (não reabrir) */
  alreadyOpened: boolean;
  /** Query de execuções ainda carregando? Se sim, não decidir ainda. */
  executionsLoading: boolean;
  /** Quantidade de execuções já existentes pro agente. */
  executionsCount: number;
  /** Usuário está olhando uma run passada selecionada? */
  isViewingPastRun: boolean;
  /** Status da execução atual ("idle", "running", "paused", ...). */
  executionStatus: string;
  /** Agente travado por dependência de pipeline? */
  isLocked: boolean;
}

export function shouldAutoOpenConfigDrawer({
  alreadyOpened,
  executionsLoading,
  executionsCount,
  isViewingPastRun,
  executionStatus,
  isLocked,
}: AutoOpenConfigInput): boolean {
  if (alreadyOpened) return false;
  if (executionsLoading) return false; // espera a lista resolver antes de decidir
  if (isViewingPastRun) return false;
  if (executionStatus !== "idle") return false;
  if (executionsCount > 0) return false;
  if (isLocked) return false;
  return true;
}
